export function TheCalligrapherIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M8 38c4-6 8-2 12-8s4-10 8-16c2-4 6-6 10-6" />
      <path d="M38 8c2 0 4 2 2 4l-4 4" />
      <path d="M12 40c8-2 12-4 18-10" />
      <circle cx="10" cy="40" r="2" />
    </svg>
  );
}
